import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
//中台
import userCenter from './mp/user_center'
import wechat from './mp/wechat'
import shops from './mp/shops'
import payManage from './mp/pay_manage'
import vmall from './mp/vmall'
import home from './mp/home'
import finance from './mp/finance'
import vipCard from './mp/vip_card'
import marketing from './mp/marketing'

//后台
import business from './mg/business'
import message from './mg/message'
import mgHome from './mg/home'
const store = new Vuex.Store({
	modules: {
        ...userCenter,
        ...wechat,
        ...shops,
        ...payManage,
        vmall,
        home,
        business,
        message,
        mgHome,
        finance,
        vipCard,
        ...marketing
    }
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js